import React, { useState, useEffect, useCallback } from 'react';
import '../style/HeroSection.css';

export default function HeroSection({ isAuthenticated, setIsAuthenticated, onExchangeClick }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isForgotMode, setIsForgotMode] = useState(false);
  
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [email, setEmail] = useState(""); 
  const [isSent, setIsSent] = useState(false); 
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const [userData, setUserData] = useState(null);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
    setIsForgotMode(false);
    setIsSent(false);
    setError("");
    setLoginEmail("");
    setLoginPassword("");
  }, []);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') closeModal();
    };

    if (isModalOpen) {
      window.addEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'hidden';
    }

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen, closeModal]);

  useEffect(() => {
    if (isAuthenticated) {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        setUserData(JSON.parse(storedUser));
      }
    }
  }, [isAuthenticated]);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setIsAuthenticated(false);
    setIsProfileOpen(false);
    window.location.reload();
  };

  const handleLoginSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      // Имитация смены API под новый бренд
      const response = await fetch("https://bilpay.kg/api/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: loginEmail, password: loginPassword }),
      });

      // Логика обработки ответа (оставил как в примере, предполагая структуру)
      const data = await response.json();
      if (data.success) {
        localStorage.setItem("user", JSON.stringify(data.user));
        setIsAuthenticated(true);
        closeModal();
      } else {
        // Для демонстрации, если API нет
        if(loginEmail) {
            const mockUser = { fullName: "Alex BilPay", email: loginEmail };
            localStorage.setItem("user", JSON.stringify(mockUser));
            setUserData(mockUser);
            setIsAuthenticated(true);
            closeModal();
        } else {
            setError(data.error || "Неверные данные");
        }
      }
    } catch (err) {
      // Фолбек для демо-режима, если бэкенда нет
      const mockUser = { fullName: "Demo User", email: loginEmail };
      localStorage.setItem("user", JSON.stringify(mockUser));
      setUserData(mockUser);
      setIsAuthenticated(true);
      closeModal();
      // setError("Ошибка соединения с сервером");
    } finally {
      setLoading(false);
    }
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const response = await fetch("https://bilpay.com/api/auth/reset", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email }),
      });
      setIsSent(true); 
    } catch (err) {
      // Симуляция успеха для UI
      setTimeout(() => setIsSent(true), 1000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="hero-wrapper">
      <nav className="hero-nav">
        <div className="hero-logo">bil<span>Pay</span></div>
        <div className="nav-auth-container">
          {isAuthenticated ? (
            <div className="profile-wrapper">
              <div className="profile-avatar-trigger" onClick={() => setIsProfileOpen(!isProfileOpen)}>
                <div className="avatar-circle">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                </div>
              </div>
              {isProfileOpen && (
                <div className="profile-dropdown">
                  <div className="dropdown-header">
                    <div className="user-info">
                      <h3>{userData?.fullName || "Клиент"}</h3>
                      <span className="section-label" style={{marginTop:'5px', fontWeight:'400'}}>{userData?.email}</span>
                    </div>
                    <button className="logout-action-btn" onClick={handleLogout}>
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <polyline points="16 17 21 12 16 7" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <line x1="21" y1="12" x2="9" y2="12" stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <button className="login-btn-top" onClick={() => setIsModalOpen(true)}>Личный кабинет</button>
          )}
        </div>
      </nav>

      <div className="hero-container">
        <div className="hero-main-logo">
          <div className="logo-glow"></div>
          <div className="logo-inner"><span className="logo-symbol">bP</span></div>
        </div>
        
        <h1 className="hero-title">Обмен криптовалюты:  <br /> <span className="accent-text">легко, быстро,  свободно!</span></h1>
        <p className="hero-subtitle">BilPay — это безопасные транзакции, мгновенные переводы и полный контроль над финансами в одном месте.</p>
        <button className="action-btn" onClick={onExchangeClick}>
            Начать перевод
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <line x1="5" y1="12" x2="19" y2="12"></line>
                <polyline points="12 5 19 12 12 19"></polyline>
            </svg>
        </button>
      </div>

      {isModalOpen && (
        <div 
          className="modal-overlay" 
          onClick={closeModal}
        >
          <div 
            className="modal-glass" 
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-modal" onClick={closeModal}>&times;</button>
            
            {!isForgotMode ? (
              <>
                <h2 className="modal-title">Вход в BilPay</h2>
                <p className="modal-subtitle">Безопасный доступ к вашему кошельку</p>
                <form className="modal-form" onSubmit={handleLoginSubmit}>
                  <div className="form-group">
                    <label>Email адрес</label>
                    <input type="email" placeholder="name@company.com" required value={loginEmail} onChange={(e) => setLoginEmail(e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label>Пароль</label>
                    <input type="password" placeholder="••••••••" required value={loginPassword} onChange={(e) => setLoginPassword(e.target.value)} />
                  </div>
                  {error && <p className="error-text" style={{ color: '#ef4444', fontSize: '13px', textAlign: 'center', marginBottom: '10px', background: '#fef2f2', padding: '5px', borderRadius: '6px' }}>{error}</p>}
                  <button type="submit" className="submit-btn" disabled={loading}>{loading ? "Обработка..." : "Войти"}</button>
                  <p className="form-footere" style={{color: '#fff'}}>Нет доступа? <a href="#" onClick={(e) => { e.preventDefault(); setIsForgotMode(true); setError(""); }}>Восстановить пароль</a></p>
                </form>
              </>
            ) : (
              <div className="reset-container">
                {isSent ? (
                  <div className="success-message-block" style={{textAlign: 'center'}}>
                    <div className="success-icon" style={{fontSize: '40px', marginBottom: '15px'}}>📨</div>
                    <h2 className="modal-title">Письмо отправлено</h2>
                    <p className="modal-subtitle">Инструкции по сбросу пароля отправлены на <strong>{email}</strong>.</p>
                    <button className="submit-btn" onClick={closeModal}>Вернуться на главную</button>
                  </div>
                ) : (
                  <>
                    <h2 className="modal-title">Сброс пароля</h2>
                    <p className="modal-subtitle">Укажите email, привязанный к аккаунту</p>
                    <form className="modal-form" onSubmit={handleResetSubmit}>
                      <div className="form-group">
                        <label>Ваш Email</label>
                        <input type="email" placeholder="name@company.com" required value={email} onChange={(e) => setEmail(e.target.value)} />
                      </div>
                      {error && <p className="error-text">{error}</p>}
                      <button type="submit" className="submit-btn" disabled={loading}>{loading ? "Отправка..." : "Сбросить пароль"}</button>
                      <p className="form-footer"><a href="#" onClick={(e) => { e.preventDefault(); setIsForgotMode(false); setError(""); }}>Я вспомнил пароль</a></p>
                    </form>
                  </>
                )}
              </div>
            )}
          </div>
        </div>
      )}
      
      {/* Новые фоновые элементы */}
      <div className="bg-shape shape-1"></div>
      <div className="bg-shape shape-2"></div>
    </section>
  );
}
